// Modules
import { createApi } from '@reduxjs/toolkit/query/react';

// Utils
import { endpoints } from 'config/api';
import { axiosBaseQuery } from 'config/axiosBaseQuery';
import { ProjectTemplate, CreateProjectTemplateDto, UpdateProjectTemplateDto } from './projectTemplatesTypes';

export const projectsTemplatesApi = createApi({
  reducerPath: 'projectsTemplatesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['ProjectsTemplates'],
  endpoints: (builder) => ({
    getProjectsTemplates: builder.query<ProjectTemplate[], void>({
      query: () => ({
        url: endpoints.projectsTemplates.base,
        method: 'GET',
      }),
      providesTags: ['ProjectsTemplates'],
    }),

    getProjectsTemplate: builder.query<ProjectTemplate, string>({
      query: (id) => ({
        url: `${endpoints.projectsTemplates.base}/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'ProjectsTemplates', id }],
    }),

    createProjectsTemplate: builder.mutation<ProjectTemplate, CreateProjectTemplateDto>({
      query: (templateData) => ({
        url: endpoints.projectsTemplates.base,
        method: 'POST',
        data: templateData,
      }),
      invalidatesTags: ['ProjectsTemplates'],
    }),

    updateProjectsTemplate: builder.mutation<ProjectTemplate, { id: string; data: UpdateProjectTemplateDto }>({
      query: ({ id, data }) => ({
        url: `${endpoints.projectsTemplates.base}/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['ProjectsTemplates'],
    }),

    deleteProjectsTemplate: builder.mutation<void, string>({
      query: (templateId) => ({
        url: `${endpoints.projectsTemplates.base}/${templateId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ProjectsTemplates'],
    }),
  })
});

export const {
  useGetProjectsTemplatesQuery,
  useGetProjectsTemplateQuery,
  useCreateProjectsTemplateMutation,
  useUpdateProjectsTemplateMutation,
  useDeleteProjectsTemplateMutation,
} = projectsTemplatesApi;
